import { Routes, Route, Navigate } from 'react-router-dom';

import CredCockpit from './screens/aquisicao/cessao/lotes';
import DetailsCockpit from './screens/aquisicao/cessao/detalhe_lote';
import DetalhesContrato from './screens/aquisicao/cessao/detalhe_contrato';
import CessoesOverview from './screens/aquisicao/aquisicoes';
import Home from './screens/pagina_inicial';
import CadastroAdmin from './screens/cadastros/admin';
import CadastroCedente from './screens/cadastros/cedente';
import FundoDispatcher from './screens/cadastros/fundo_dispatcher';
import Prestadores from './screens/cadastros/prestadores';
import CadastroAtivo from './screens/cadastros/ativos';
import TiposAtivo from './screens/cadastros/ativos/TiposAtivo';
import PortfolioAtivos from './screens/cadastros/ativos/Portfolio';
import CadastroUsuario from './screens/cadastros/usuario';
import CadastroOriginador from './screens/cadastros/originador';
import Registros from './screens/aquisicao/registros';
import Lastros from './screens/aquisicao/lastros';
import ConciliacoesGerais from './screens/conciliacoes/conciliacoes-gerais';
import ConciliacaoDetalhe from './screens/conciliacoes/conciliacao-detalhe';
import Documentos from './screens/documentos';
import PageNotFound from './components/PageNotFound';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/aquisicao/operacoes" element={<CredCockpit />} />
      <Route path="/aquisicao/operacoes/detalhes/:id" element={<DetailsCockpit />} />
      <Route path="/aquisicao/operacoes/detalhes/:id/:numero_documento" element={<DetalhesContrato />} />
      <Route path="/aquisicao/operacoes/overview" element={<CessoesOverview />} />
      <Route path="/aquisicao/registros" element={<Registros />} />
      <Route path="/aquisicao/lastros" element={<Lastros />} />
      <Route path="/conciliacoes/gerais" element={<ConciliacoesGerais />} />
      <Route path="/conciliacoes/gerais/detalhes" element={<ConciliacaoDetalhe />} />
      <Route path="/documentos" element={<Documentos />} />
      <Route path="/cadastros/cadastro-admin" element={<CadastroAdmin />} />
      <Route path="/cadastros/cadastro-cedente" element={<CadastroCedente />} />

      {/* Fundos: rota única, tela decidida pelo :tipo (liquidos | estruturados) */}
      <Route path="/cadastro/fundo/:tipo" element={<FundoDispatcher />} />
      {/* detalhe de um fundo específico (id na URL) */}
      <Route path="/cadastro/fundo/:tipo/:fundoId" element={<FundoDispatcher />} />
      <Route path="/cadastro/fundo" element={<Navigate to="/cadastro/fundo/liquidos" replace />} />
      {/* redirects das URLs antigas (compatibilidade) */}
      <Route path="/cadastros/cadastro-fundo-liquido" element={<Navigate to="/cadastro/fundo/liquidos" replace />} />
      <Route path="/cadastros/cadastro-fundo" element={<Navigate to="/cadastro/fundo/estruturados" replace />} />
      <Route path="/cadastros/fundo" element={<Navigate to="/cadastro/fundo/estruturados" replace />} />

      {/* Prestadores: listagem + detalhe (id na URL) + cadastro */}
      <Route path="/cadastro/prestador" element={<Prestadores />} />
      <Route path="/cadastro/prestador/:id" element={<Prestadores />} />

      {/* Ativos: lista de tipos → cadastro do tipo + portfolio (listagem) */}
      <Route path="/cadastro/ativo" element={<TiposAtivo />} />
      <Route path="/cadastro/ativo/:tipo" element={<CadastroAtivo />} />
      <Route path="/ativos/portfolio" element={<PortfolioAtivos />} />

      <Route path="/cadastros/cadastro-originador" element={<CadastroOriginador />} />
      <Route path="/cadastros/cadastro-usuario" element={<CadastroUsuario />} />
      <Route path="/" element={<Home />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default AppRoutes;